import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class FacilityGroupsApi {
  static getFacilityGroupsForForms = async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.organizationId) {
      queryParams.append('organization_id', params.organizationId);
    }

    const queryString = queryParams.toString();
    const response = await axios.get(
      `${API_BASE_URL}/facility-groups/for-forms${
        queryString ? `?${queryString}` : ''
      }`,
    );
    return response.data?.facility_groups;
  };

  static getFacilityGroups = (organizationId, params = {}) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups`,
      { params },
    );
  };

  static getFacilityGroupTree = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/tree`,
    );
  };

  static getFacilityGroup = (organizationId, groupId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/${groupId}`,
    );
  };

  static createFacilityGroup = (organizationId, data) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups`,
      data,
    );
  };

  static updateFacilityGroup = (organizationId, groupId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/${groupId}`,
      data,
    );
  };

  static deleteFacilityGroup = (organizationId, groupId) => {
    return axios.delete(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/${groupId}`,
    );
  };

  static assignFacilities = (organizationId, groupId, facilityIds) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/${groupId}/assign-facilities`,
      { facility_ids: facilityIds },
    );
  };

  static removeFacilities = (organizationId, groupId, facilityIds) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/facility-groups/${groupId}/remove-facilities`,
      { facility_ids: facilityIds },
    );
  };
}
